"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _Select = _interopRequireDefault(require("@material-ui/core/Select"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));
var _FormGroup = _interopRequireDefault(require("@material-ui/core/FormGroup"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));
var _pickers = require("@material-ui/pickers");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class MTableEditField extends React.Component {
  getProps() {
    const _this$props = this.props,
      {
        columnDef,
        rowData,
        onRowDataChange,
        errorState,
        onBulkEditRowChanged,
        scrollWidth
      } = _this$props,
      props = (0, _objectWithoutProperties2.default)(_this$props, ["columnDef", "rowData", "onRowDataChange", "errorState", "onBulkEditRowChanged", "scrollWidth"]);
    return props;
  }
  renderLookupField() {
    const _this$getProps = this.getProps(),
      {
        helperText,
        error
      } = _this$getProps,
      props = (0, _objectWithoutProperties2.default)(_this$getProps, ["helperText", "error"]);
    const lookupType = typeof this.props.columnDef.lookupWhenEdit;
    const lookup = lookupType === "function" ? this.props.columnDef.lookupWhenEdit(this.props.rowData) : lookupType === "object" ? this.props.columnDef.lookupWhenEdit : this.props.columnDef.lookup;
    return /*#__PURE__*/React.createElement(_FormControl.default, {
      error: Boolean(error)
    }, /*#__PURE__*/React.createElement(_Select.default, (0, _extends2.default)({}, props, {
      value: this.props.value === undefined ? "" : this.props.value,
      onChange: event => this.props.onChange(event.target.value),
      style: {
        fontSize: 13
      },
      SelectDisplayProps: {
        "aria-label": this.props.columnDef.title
      }
    }), Object.entries(lookup).map(_ref => {
      let [key, value] = _ref;
      return /*#__PURE__*/React.createElement(_MenuItem.default, {
        key: key,
        value: key
      }, value);
    })), Boolean(helperText) && /*#__PURE__*/React.createElement(_FormHelperText.default, null, helperText));
  }
  renderBooleanField() {
    const _this$getProps2 = this.getProps(),
      {
        helperText,
        error
      } = _this$getProps2,
      props = (0, _objectWithoutProperties2.default)(_this$getProps2, ["helperText", "error"]);
    return /*#__PURE__*/React.createElement(_FormControl.default, {
      error: Boolean(error),
      component: "fieldset"
    }, /*#__PURE__*/React.createElement(_FormGroup.default, null, /*#__PURE__*/React.createElement(_FormControlLabel.default, {
      label: "",
      control: /*#__PURE__*/React.createElement(_Checkbox.default, (0, _extends2.default)({}, props, {
        value: String(this.props.value),
        checked: Boolean(this.props.value),
        onChange: event => this.props.onChange(event.target.checked),
        style: {
          padding: 0,
          width: 24,
          marginLeft: 9
        },
        inputProps: {
          "aria-label": this.props.columnDef.title
        }
      }))
    })), /*#__PURE__*/React.createElement(_FormHelperText.default, null, helperText));
  }
  renderDateField() {
    const dateFormat = this.props.columnDef.dateSetting && this.props.columnDef.dateSetting.format ? this.props.columnDef.dateSetting.format : "dd.MM.yyyy";
    return /*#__PURE__*/React.createElement(_pickers.MuiPickersUtilsProvider, {
      utils: _dateFns.default,
      locale: this.props.locale
    }, /*#__PURE__*/React.createElement(_pickers.DatePicker, (0, _extends2.default)({}, this.getProps(), {
      format: dateFormat,
      value: this.props.value || null,
      onChange: this.props.onChange,
      clearable: true,
      InputProps: {
        style: {
          fontSize: 13
        }
      },
      inputProps: {
        "aria-label": "".concat(this.props.columnDef.title, ": press space to edit")
      }
    })));
  }
  renderTimeField() {
    return /*#__PURE__*/React.createElement(_pickers.MuiPickersUtilsProvider, {
      utils: _dateFns.default,
      locale: this.props.locale
    }, /*#__PURE__*/React.createElement(_pickers.TimePicker, (0, _extends2.default)({}, this.getProps(), {
      format: "HH:mm:ss",
      value: this.props.value || null,
      onChange: this.props.onChange,
      clearable: true,
      InputProps: {
        style: {
          fontSize: 13
        }
      },
      inputProps: {
        "aria-label": "".concat(this.props.columnDef.title, ": press space to edit")
      }
    })));
  }
  renderDateTimeField() {
    return /*#__PURE__*/React.createElement(_pickers.MuiPickersUtilsProvider, {
      utils: _dateFns.default,
      locale: this.props.locale
    }, /*#__PURE__*/React.createElement(_pickers.DateTimePicker, (0, _extends2.default)({}, this.getProps(), {
      format: "dd.MM.yyyy HH:mm:ss",
      value: this.props.value || null,
      onChange: this.props.onChange,
      clearable: true,
      InputProps: {
        style: {
          fontSize: 13
        }
      },
      inputProps: {
        "aria-label": "".concat(this.props.columnDef.title, ": press space to edit")
      }
    })));
  }
  renderTextField() {
    return /*#__PURE__*/React.createElement(_TextField.default, (0, _extends2.default)({}, this.getProps(), {
      fullWidth: true,
      style: this.props.columnDef.type === "numeric" ? {
        float: "right"
      } : {},
      type: this.props.columnDef.type === "numeric" ? "number" : "text",
      placeholder: this.props.columnDef.editPlaceholder || this.props.columnDef.title,
      value: this.props.value === undefined ? "" : this.props.value,
      onChange: event => this.props.onChange(this.props.columnDef.type === "numeric" ? event.target.valueAsNumber : event.target.value),
      InputProps: {
        style: {
          fontSize: 13
        }
      },
      inputProps: {
        "aria-label": this.props.columnDef.title
      }
    }));
  }
  renderCurrencyField() {
    return /*#__PURE__*/React.createElement(_TextField.default, (0, _extends2.default)({}, this.getProps(), {
      placeholder: this.props.columnDef.editPlaceholder || this.props.columnDef.title,
      style: {
        float: "right"
      },
      type: "number",
      value: this.props.value === undefined ? "" : this.props.value,
      onChange: event => {
        let value = event.target.valueAsNumber;
        if (!value && value !== 0) {
          value = undefined;
        }
        return this.props.onChange(value);
      },
      InputProps: {
        style: {
          fontSize: 13,
          textAlign: "right"
        }
      },
      inputProps: {
        "aria-label": this.props.columnDef.title
      },
      onKeyDown: this.props.onKeyDown,
      autoFocus: this.props.autoFocus
    }));
  }
  render() {
    let component = "ok";
    if (this.props.columnDef.lookup) {
      component = this.renderLookupField();
    } else if (this.props.columnDef.type === "boolean") {
      component = this.renderBooleanField();
    } else if (this.props.columnDef.type === "date") {
      component = this.renderDateField();
    } else if (this.props.columnDef.type === "time") {
      component = this.renderTimeField();
    } else if (this.props.columnDef.type === "datetime") {
      component = this.renderDateTimeField();
    } else if (this.props.columnDef.type === "currency") {
      component = this.renderCurrencyField();
    } else {
      component = this.renderTextField();
    }
    return component;
  }
}
MTableEditField.propTypes = {
  value: _propTypes.default.any,
  onChange: _propTypes.default.func.isRequired,
  columnDef: _propTypes.default.object.isRequired,
  locale: _propTypes.default.object
};
var _default = exports.default = MTableEditField;